/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import Modal from "react-responsive-modal";
import DifferenceComponent from "../../../admin/test-dashboard/difference/difference";
import Button from "../../button";
import InputField from "../../input-field";

// Interface for component Props
interface SaveTestCasePopupProps {
  open: boolean;
  close: () => void;
  t?: any;
  questionType?: string;
  save: (input: string) => void;
  handleSaveTestInputChange?: (value: string) => void;
  tagsList: any;
  isDuplicateTestCase: boolean;
  popupLabel?: string;
  currentTestCaseName?: string;
  buttonType?: string;
}

// Interface for component State
interface SaveTestCasePopupState {
  input: any;
  isEmptyName: boolean;
  isDuplicateTestCaseState: boolean;
  saveTestPopupLabel: string;
}

/**
 * Save Test Case Popup Component.
 *
 * @namespace SaveTestCasePopup
 */

class SaveTestCasePopup extends Component<
  SaveTestCasePopupProps,
  SaveTestCasePopupState
> {
  constructor(props: SaveTestCasePopupProps) {
    super(props);
    this.state = {
      input: "",
      isEmptyName: false,
      isDuplicateTestCaseState: false,
      saveTestPopupLabel: "",
    };
  }
  handleOnKeyPress = (event: any) => {
    if (event.key === "Enter" || event.key === " ") {
      this.props.close();
    }
  };

  handleInputChange = (e: any) => {
    // const { inputPlaceHolder, questionValue, questionTitle, questionType } =
    //   this.props;

    const { input } = this.state;
    this.setState(
      {
        input: e.target.value,
        isDuplicateTestCaseState: false,
      },
      () => {
        if (input && input?.trim()?.length === 0) {
          this.setState({
            isEmptyName: true,
          });
        } else {
          this.setState({
            isEmptyName: false,
          });
        }

        // if (this.props.handleSaveTestInputChange) {
        //   this.props.handleSaveTestInputChange(e.target.value);
        // }
      }
    );
  };

  componentDidMount = () => {
    const { isDuplicateTestCase, buttonType, currentTestCaseName } = this.props;

    this.setState({
      isDuplicateTestCaseState: isDuplicateTestCase,
      input: buttonType === "update" ? currentTestCaseName : "",
      saveTestPopupLabel:
        buttonType === "create" ? "Save New Test Case" : "Save New Version",
    });
  };

  // componentDidUpdate = () => {
  //   const { isDuplicateTestCase } = this.props;
  //   const { isDuplicateTestCaseState } = this.state;
  //   if (
  //     isDuplicateTestCase !== isDuplicateTestCaseState
  //     // isDuplicateTestCase === true
  //   ) {
  //     this.setState({
  //       isDuplicateTestCaseState: isDuplicateTestCase,
  //     });
  //   }
  // };

  componentWillReceiveProps = (props: any) => {
    const { isDuplicateTestCase } = this.props;
    const { isDuplicateTestCaseState } = this.state;
    if (isDuplicateTestCase === isDuplicateTestCaseState) {
      this.setState({
        isDuplicateTestCaseState: props.isDuplicateTestCase,
      });
    }
  };

  render() {
    const {
      open,
      questionType,
      tagsList,
      isDuplicateTestCase,
      popupLabel,
      currentTestCaseName,
      buttonType,
    } = this.props;

    const { input, isEmptyName, isDuplicateTestCaseState, saveTestPopupLabel } =
      this.state;

    let errorMessage: string = "";
    if (isEmptyName) {
      errorMessage = "Enter the name of the test case here";
    }
    if (isDuplicateTestCaseState) {
      errorMessage = "A test case with this name already exists";
    }
    return (
      <div>
        <Modal
          open={open}
          onClose={() => {
            if (this.props.close) {
              this.setState({
                isDuplicateTestCaseState: false,
                isEmptyName: false,
                //input: "",
              });

              this.props.close();
            }
          }}
          center
          classNames={{
            overlay: "custom-overlay",
            modal: "modal-container save-test-case-modal",
            closeButton: "hide",
          }}
        >
          <div className="popup-wrapper">
            <div className="popup-header-container">
              <div
                tabIndex={0}
                role="button"
                className="popup-close-icon"
                onClick={() => {
                  if (this.props.close) {
                    this.setState({
                      isDuplicateTestCaseState: false,
                      isEmptyName: false,
                      //input: "",
                    });

                    this.props.close();
                  }
                }}
                //onClick={this.props.close}
                onKeyPress={this.handleOnKeyPress}
              >
                <span className="icon close-icon"></span>
              </div>
              <div className="popup-header">
                <div className="popup-label">{saveTestPopupLabel}</div>
              </div>
            </div>
            <div className="popup-inner-wrapper">
              {/* input field container Start */}
              <div className="input-container">
                <InputField
                  type="text"
                  placeHolder={"Enter the name of the test case here"}
                  className={
                    isEmptyName || isDuplicateTestCaseState
                      ? "custom-input name error-input"
                      : "custom-input"
                  }
                  // handleInputChange={(e: any) => {
                  //   this.setState({
                  //     testCaseName: e.target.value,
                  //     isEmptyValue: false,
                  //   });
                  // }}
                  handleInputChange={(e: any) => {
                    this.handleInputChange(e);
                  }}
                  inputValue={input}
                  errorMsg={errorMessage}
                  isError={isEmptyName || isDuplicateTestCaseState}
                  // inputLabel={"First Name"} //question_label
                  inputLabel={"Test Case Name"}
                  autoFocusOnInput
                  isInputDisable={buttonType === "update" ? true : false}
                />
              </div>
              {/* input field container Ends */}

              {/* Tags container start */}
              {tagsList && tagsList.length > 0 && (
                <div className={"tags-container"}>
                  <div className="title">Filters</div>
                  <div className="tags-wrapper">
                    <div className="tags-list">
                      {tagsList.map((item: any) => (
                        <div className="tags">
                          <span className="label">{item}</span>
                        </div>
                      ))}

                      {/* <span className="label">{"item"}</span> */}
                    </div>
                  </div>
                </div>
              )}

              {/* Tags container Ends */}
            </div>
            <div className="popup-button-wrapper">
              <div className="btn-wrapper">
                <Button
                  name={"Cancel"}
                  className="app-btn border-btn"
                  onButtonClick={this.props.close}
                />
              </div>

              <div className="btn-wrapper">
                <Button
                  name={"Save"}
                  className="app-btn "
                  onButtonClick={() => {
                    if (this.props.save) {
                      if (input === "") {
                        this.setState({
                          isEmptyName: true,
                        });
                      } else {
                        this.props.save(input);
                      }
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default SaveTestCasePopup;
